import React from 'react';

const Industries = () => (
  <section className="py-20 px-4 bg-white text-center">
    <h2 className="text-3xl font-bold mb-8">Industries We Serve</h2>
    <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-8">
      <div className="bg-gray-100 p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-xl font-semibold mb-2">Food & Beverage</h3>
        <p>Ensuring clean water for production, processing, and packaging.</p>
      </div>
      <div className="bg-gray-100 p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-xl font-semibold mb-2">Pharmaceuticals</h3>
        <p>Providing ultrapure water for manufacturing and lab processes.</p>
      </div>
      <div className="bg-gray-100 p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-xl font-semibold mb-2">Textile & Dyeing</h3>
        <p>Water treatment solutions for efficient textile and dye processes.</p>
      </div>
    </div>
  </section>
);

export default Industries;
